<script setup lang="ts">
import { CSSProperties, PropType, ref, computed } from 'vue'
import { CloseOutlined, CheckOutlined } from '@ant-design/icons-vue'
import { fileSize } from '@/utils/file'
import { CommonType } from '@/interface'
const props = defineProps({
  file: {
    type: File as PropType<File>,
    required: true
  },
  index: Number as PropType<number>,
  complete: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  params: Object as PropType<CommonType>
})

const style = ref<CSSProperties>({
  color: '#99'
})

const curSize = computed(() => fileSize(props.file.size))

const percentage = ref<number>(0)
const cancelRequest = () => {
  if (!props.complete) {
    // this.cancel()
    // this.$emit('delete', this.index)
  }
}
const iconStyle = ref<CSSProperties>({
  fontSize: '16px',
  fontWeight: 'bold'
})
</script>

<template>
  <div class="wk-upload-cell display-flex">
    <!-- <img :src="fileIcon" class="wk-upload-cell__header" /> -->
    <div class="wk-upload-cell__body">
      <div class="text-one-line">
        {{ file.name }}<span :style="style">{{ curSize }}</span>
      </div>
      <a-progress :stroke-width="3" type="link" :show-info="false" :percent="complete ? 100 : percentage" />
    </div>
    <div class="wk-upload-cell__footer">
      <a-button type="text" @click="cancelRequest">
        <template>
          <close-outlined v-show="complete" :style="iconStyle" />
          <check-outlined v-show="!complete" :style="iconStyle" />
        </template>
      </a-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.wk-upload-cell {
  padding: 8px 15px;
  font-size: 12px;
  background-color: #f0f0f0;
  border-radius: 4px;

  &__header {
    margin-right: 15px;
    width: 17px;
    height: 20px;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    width: 0;

    .el-progress {
      margin-top: 8px;
    }
  }

  &__footer {
    flex-shrink: 0;
    margin-left: 10px;

    .ant-button {
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      font-weight: bold;

      // :deep(i) {
      //   font-size: 15px;
      //   font-weight: bold;
      // }
    }
  }
}
</style>
